import React from 'react';

const PageHero = ({ eyebrow = 'Africa Systems', title, description, image, children }) => {
  return (
    <section className="relative bg-[#0a1628] text-white overflow-hidden">
      {image ? (
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{ backgroundImage: `url(${image})` }}
        />
      ) : null}
      <div className="absolute inset-0 bg-[#0a1628]/70" />
      <div className="absolute inset-0 bg-gradient-to-r from-[#0a1628]/95 via-[#0a1628]/60 to-[#0a1628]/20" />

      <div className="relative max-w-[1400px] mx-auto px-5 sm:px-8 lg:px-12 py-20 lg:py-28">
        <div className="max-w-3xl">
          <div className="flex items-center gap-3 mb-6">
            <span className="w-8 h-px bg-[#16A34A]" />
            <span className="text-[11px] font-semibold tracking-[0.22em] uppercase text-[#16A34A]">
              {eyebrow}
            </span>
          </div>
          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight leading-[1.05]">
            {title}
          </h1>
          {description ? (
            <p className="mt-6 text-white/75 text-base md:text-lg leading-relaxed max-w-2xl">
              {description}
            </p>
          ) : null}
          {children ? <div className="mt-8 flex flex-wrap gap-4">{children}</div> : null}
        </div>
      </div>
    </section>
  );
};

export default PageHero;